import { computed } from 'vue';
import EventBus from '../../scripts/lib/EventBus.js';

const templateElement = document.getElementById('groessen-item-template');

export default {
  template: templateElement ? templateElement.innerHTML : '',

  props: ['item', 'farbe', 'itempreis', 'aktiv', 'vertriebsinfoId', 'showPrice'],
  emits: ['bewerten-vue-groesse-clicked'],
  setup(props, ctx) {
    const isAktiv = computed(() => props.aktiv.name === props.item.name);

    function selectSize() {
      ctx.emit('bewerten-vue-groesse-clicked', props.item.artikelNr);
      if (props.item.outOfStock) {
        EventBus.emit('bewerten:out-of-stock-layer:show', props.vertriebsinfoId);
      }
    }

    return { isAktiv, selectSize };
  },
};
